export enum Rychla6BetType {
    MainGame = "0",
    EvenOdd = "1",
    LowHigh = "2",
}

export enum Rychla6BetEvenOdd {
    Odd = 1,
    Equal = 2,
    Even = 3,
}

export enum Rychla6BetLowHigh {
    Low = 1,
    Equal = 2,
    High = 3,
}
